import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { OvertimeResolutionPayload } from './overtime.interface';

export interface OvertimeResolutionDialogData {
  mode: 'approve' | 'reject';
  detectedMinutes?: number | null;
}

@Component({
  selector: 'app-overtime-resolution-dialog',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatInputModule, TranslateModule],
  templateUrl: './overtime-resolution-dialog.component.html',
  styleUrl: './overtime-resolution-dialog.component.scss',
})
export class OvertimeResolutionDialogComponent {
  readonly mode = this.data.mode;
  readonly approvedMinutesControl = new FormControl<number | null>(this.data.detectedMinutes ?? null, [Validators.min(0)]);
  readonly commentControl = new FormControl<string>('');

  constructor(
    @Inject(MAT_DIALOG_DATA) private readonly data: OvertimeResolutionDialogData,
    private readonly dialogRef: MatDialogRef<OvertimeResolutionDialogComponent, OvertimeResolutionPayload | null>,
    private readonly translate: TranslateService
  ) {}

  get title(): string {
    return this.translate.instant(`overtimesCatalog.dialog.${this.mode}Title`);
  }

  get description(): string {
    return this.translate.instant(`overtimesCatalog.dialog.${this.mode}Description`);
  }

  get confirmLabel(): string {
    return this.translate.instant(`overtimesCatalog.actions.${this.mode}`);
  }

  submit(): void {
    if (this.mode === 'approve' && this.approvedMinutesControl.invalid) {
      this.approvedMinutesControl.markAsTouched();
      return;
    }

    const payload: OvertimeResolutionPayload = {
      comment: (this.commentControl.value || '').trim() || undefined,
    };

    if (this.mode === 'approve' && this.approvedMinutesControl.value !== null && this.approvedMinutesControl.value !== undefined) {
      payload.approvedMinutes = Number(this.approvedMinutesControl.value);
    }

    this.dialogRef.close(payload);
  }
}
